import PropTypes from 'prop-types'
import React from 'react'

const Input = ({
  autocomplete,
  placeholder,
  classes,
  input,
  label,
  type,
  required,
  meta: { touched, error, warning },
}) => (
  <div className={classes}>
    <label className="bp3-label roboto-regular" htmlFor={input.name}>
      <span className="geo-semibold">{label}</span>
      <input
        {...input}
        className={`bp3-fill bp3-input geo-regular pv3 ${error && touched && 'bp3-intent-danger'}`}
        type={type}
        placeholder={placeholder}
        autoComplete={autocomplete}
        required={required}
      />
      {touched && error && <span className="mt1 db red roboto-regular">{error}</span>}
    </label>
  </div>
)

Input.propTypes = {
  autocomplete: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  classes: PropTypes.string,
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
}

export default Input
